import {
    BILLING_INVOICE_LIST_REQUEST, BILLING_INVOICE_LIST_SUCCESS, BILLING_INVOICE_LIST_FAIL,
    BILLING_INVOICE_DETAILS_REQUEST, BILLING_INVOICE_DETAILS_SUCCESS, BILLING_INVOICE_DETAILS_FAIL, BILLING_INVOICE_DETAILS_RESET,
    BILLING_INVOICE_CREATE_REQUEST, BILLING_INVOICE_CREATE_SUCCESS, BILLING_INVOICE_CREATE_FAIL, BILLING_INVOICE_CREATE_RESET,
    BILLING_INVOICE_UPDATE_REQUEST, BILLING_INVOICE_UPDATE_SUCCESS, BILLING_INVOICE_UPDATE_FAIL, BILLING_INVOICE_UPDATE_RESET,
    BILLING_INVOICE_DELETE_REQUEST, BILLING_INVOICE_DELETE_SUCCESS, BILLING_INVOICE_DELETE_FAIL,
    BILLING_INVOICE_DTO_REQUEST, BILLING_INVOICE_DTO_SUCCESS, BILLING_INVOICE_DTO_FAIL, BILLING_INVOICE_DTO_RESET,
    SET_CURRENT_PAGE,
} from '../constants/billingInvoiceConstants';

export const billingInvoiceListReducer = (state = { billingInvoices: [] }, action) => {
    switch (action.type) {
        case BILLING_INVOICE_LIST_REQUEST:
            return { loading: true, billingInvoices: [] };
        case BILLING_INVOICE_LIST_SUCCESS:
            return {
                loading: false,
                billingInvoices: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case SET_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.payload
            };
        case BILLING_INVOICE_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const billingInvoiceDetailsReducer = (state = { billingInvoice: {} }, action) => {
    switch (action.type) {
        case BILLING_INVOICE_DETAILS_REQUEST:
            return { loading: true, ...state };
        case BILLING_INVOICE_DETAILS_SUCCESS:
            return { loading: false, billingInvoice: action.payload };
        case BILLING_INVOICE_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case BILLING_INVOICE_DETAILS_RESET:
            return { billingInvoice: {} };
        default:
            return state;
    }
};

export const billingInvoiceDtoReducer = (state = { billingInvoiceDto: {} }, action) => {
    switch (action.type) {
        case BILLING_INVOICE_DTO_REQUEST:
            return { loading: true, billingInvoiceDto: {} };
        case BILLING_INVOICE_DTO_SUCCESS:
            return { loading: false, billingInvoiceDto: action.payload };
        case BILLING_INVOICE_DTO_FAIL:
            return { loading: false, error: action.payload };
        case BILLING_INVOICE_DTO_RESET:
            return { billingInvoiceDto: {} };
        default:
            return state;
    }
};

export const billingInvoiceDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case BILLING_INVOICE_DELETE_REQUEST:
            return { loading: true };
        case BILLING_INVOICE_DELETE_SUCCESS:
            return { loading: false, success: true };
        case BILLING_INVOICE_DELETE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const billingInvoiceCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case BILLING_INVOICE_CREATE_REQUEST:
            return { loading: true };
        case BILLING_INVOICE_CREATE_SUCCESS:
            return { loading: false, success: true, billingInvoice: action.payload };
        case BILLING_INVOICE_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case BILLING_INVOICE_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const billingInvoiceUpdateReducer = (state = { billingInvoice: {} }, action) => {
    switch (action.type) {
        case BILLING_INVOICE_UPDATE_REQUEST:
            return { loading: true };
        case BILLING_INVOICE_UPDATE_SUCCESS:
            return { loading: false, success: true, billingInvoice: action.payload };
        case BILLING_INVOICE_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case BILLING_INVOICE_UPDATE_RESET:
            return { billingInvoice: {} };
        default:
            return state;
    }
}; 